module.exports = __webpack_public_path__ + "img/newmember_pop_up_limited_time@2x.9ee927d0.png";